import React, { ReactNode } from 'react';

import { CmCard, CmText } from '@/components/uiParts';

type Props = {
  width?: string;
  margin: string;
  children: ReactNode;
};

export const CmMessageCard: React.FC<Props> = ({
  children,
  width = 'fit-content',
  margin,
}) => {
  return (
    <CmCard {...{ width, margin }}>
      <CmText alignSelf="center" fontWeight="bold" margin="0">
        {children}
      </CmText>
    </CmCard>
  );
};
